export const categories = [
  {
    slug: "movie",
    name: "电影",
    icon: "ri-film-line",
    desc: "精选院线大片与经典影片，涵盖动作、科幻、爱情、剧情等多种题材。",
    tint: "primary",
  },
  {
    slug: "tv",
    name: "电视剧",
    icon: "ri-tv-2-line",
    desc: "热播电视剧集同步更新，都市、悬疑、年代题材一网打尽。",
    tint: "accent",
  },
  {
    slug: "chinese-drama",
    name: "国产剧",
    icon: "ri-ancient-gate-line",
    desc: "国产优质剧集，古装权谋、都市情感、家庭伦理应有尽有。",
    tint: "secondary",
  },
  {
    slug: "overseas-drama",
    name: "海外剧",
    icon: "ri-earth-line",
    desc: "欧美、日韩等地口碑剧集，感受不同文化的叙事魅力。",
    tint: "primary",
  },
  {
    slug: "variety",
    name: "综艺",
    icon: "ri-mic-line",
    desc: "真人秀、音乐竞演、美食旅行等热门综艺，轻松解压。",
    tint: "accent",
  },
  {
    slug: "anime",
    name: "动漫",
    icon: "ri-vip-diamond-line",
    desc: "热血番剧与治愈日常，国产动画与日系新番集结地。",
    tint: "secondary",
  },
];